/**
 * Change first letter for a string
 *
 * @param {string} str String to change
 * @param {boolean} capitalize If capitalize change first letter to uppercase
 * @returns {string} Modified string
 */
function firstLetter(str, capitalize = true) {
  let output = str
    .charAt(0)[capitalize
      ? 'toUpperCase'
      : 'toLowerCase']();
  output += str
    .slice(1);

  return output;
}

/**
 * Parse string values to JavaScript data types
 *
 * @param {string} str
 * @returns {any}
 */
function parseValue(str) {
  let val = str.trim();

  if (val === 'true') {
    val = true;
  } else if (val === 'false') {
    val = false;
  }

  if (String(parseFloat(val)) === val) {
    val = parseFloat(val) || val;
  }

  return val;
}

/**
 * Pupulate string with values in object
 *
 * @param {string} str String to populate
 * @param {object} values Data to populate string
 * @param {string} prefix Prefix for replacement values
 * @returns {string} Populate string
 */
function populate(str, values = {}, prefix = ':') {
  let output = str;

  for (const [k, v] of Object.entries(values)) {
    const key = `${prefix}${k}`;

    output = (v !== null && typeof v === 'object')
      ? populate(output, v, `${key}.`)
      : replaceAll(output, key, v);
  }

  return output;
}

/**
 *
 * @param {*} str
 * @param {*} search
 * @param {*} replacement
 * @returns
 */
function replaceAll(str, search, replacement) {
  return str
    .split(search)
    .join(replacement);
}

export {
  firstLetter,
  parseValue,
  populate,
  replaceAll,
};
